<template>
  <q-page class="bg-page q-pa-xl">
    <div class="container-md">

      <!-- Заглавие -->
      <div class="header-section q-mb-lg flex justify-between items-center">
        <div class="flex items-center">
          <!-- <q-icon name="phone_in_talk" size="26px" class="text-mint q-mr-sm" /> -->
          <h5 class="text-mint text-bold q-mb-none">Телефонски повици</h5>
        </div>

        <q-btn
          label="Нов повик"
          color="mint"
          flat
          no-caps
          icon="add_circle"
          class="btn-clean"
          @click="openAddDialog"
        />
      </div>

      <!-- Филтер -->
      <q-card flat bordered class="filter-card q-pa-md q-mb-lg shadow-xs bg-white rounded-xl">
        <div class="row items-center q-col-gutter-md">
          <div class="col-12 col-md-4">
            <q-select
              v-model="currentFilter"
              :options="filterOptions"
              label="Прикажи повици"
              dense
              outlined
              color="mint"
              class="filter-input"
              emit-value
              map-options
            />
          </div>
        </div>
      </q-card>

      <!-- Табела -->
      <q-card flat bordered class="table-card q-pa-md shadow-xs bg-white rounded-2xl">
        <q-table
          :data="filteredCalls"
          :columns="columns"
          row-key="id"
          flat
          bordered
          dense
          separator="horizontal"
          class="table-clean"
          no-data-label="Нема внесени повици."
        >
          <!-- Датум -->
          <template v-slot:body-cell-datum="props">
            <q-td align="center">{{ formatDate(props.row.datum) }}</q-td>
          </template>

          <!-- Број на налог -->
          <template v-slot:body-cell-brojNalog="props">
            <q-td align="center">{{ props.row.brojNalog || "-" }}</q-td>
          </template>

          <!-- Вработен -->
          <template v-slot:body-cell-vraboten="props">
            <q-td>{{ props.row.vrabotenIme || "-" }}</q-td>
          </template>

          <!-- Статус -->
          <template v-slot:body-cell-status="props">
            <q-td align="center">
              <q-badge :color="statusColor(props.row.status)" class="q-px-sm text-white">
                {{ props.row.status }}
              </q-badge>
            </q-td>
          </template>

          <!-- Акции -->
          <template v-slot:body-cell-akcii="props">
            <q-td align="center" class="q-gutter-xs">
              <q-btn
                v-if="props.row.status === 'непроследено'"
                flat
                dense
                color="mint"
                icon="edit"
                label=""
                no-caps
                @click="openEditDialog(props.row)"
              />

              <q-btn
                v-if="props.row._pending === true"
                flat
                dense
                color="negative"
                icon="delete"
                label=""
                no-caps
                @click="removeLocal(props.row.id)"
              />
            </q-td>
          </template>
        </q-table>
      </q-card>

      <!-- Сними -->
      <div class="q-mt-md flex flex-center">
        <q-btn
          :disable="pendingCount === 0 || saving"
          :loading="saving"
          label="Сними"
          color="mint"
          no-caps
          icon="save"
          class="btn-save-top"
          @click="saveAllPending"
        >
          <q-badge v-if="pendingCount > 0" class="q-ml-sm" color="negative" text-color="white">
            {{ pendingCount }}
          </q-badge>
        </q-btn>
      </div>

      <!-- Дијалог -->
      <q-dialog v-model="dialog" persistent>
        <q-card flat class="dialog-card shadow-2">

          <div class="dialog-title">
            {{ isEdit ? 'Измени телефонски повик' : 'Нов телефонски повик' }}
          </div>

          <q-form @submit.prevent="onSubmit" class="q-gutter-md">

            <div class="row q-col-gutter-md">
              <div class="col-12 col-md-6">
               <q-input
                v-model="novPovik.klient"
                label="Клиент"
                dense
                outlined
                color="mint"
                class="soft-input required-field"
              />
              </div>

              <div class="col-12 col-md-6">
               <q-select
              v-model="novPovik.firma"
              label="Фирма"
              dense
              outlined
              color="mint"
              :options="filteredFirmi"
              option-label="label"
              option-value="value"
              emit-value
              map-options
              use-input
              clearable
              @filter="filterFirmi"
              class="soft-input required-field"
            />
              </div>

              <div class="col-12 col-md-6">
               <q-select
                v-model="novPovik.vraboten"
                label="Вработен"
                dense
                outlined
                color="mint"
                :options="filteredVrab"
                option-label="label"
                option-value="value"
                emit-value
                map-options
                use-input
                clearable
                @filter="filterVrab"
                class="soft-input required-field"
              />
              </div>

              <div class="col-12 col-md-6">
                <q-select
                  v-model="novPovik.prosleden"
                  label="Проследен"
                  dense
                  outlined
                  color="mint"
                  :options="[
                    { label: 'Непроследен', value: false },
                    { label: 'Проследен', value: true }
                  ]"
                  emit-value
                  map-options
                  class="soft-input"
                />
              </div>
            </div>

            <div class="row q-col-gutter-md q-mt-sm">
              <div class="col-12 col-md-6">
                <q-input
                  v-model="novPovik.brojNalog"
                  label="Број на налог"
                  dense
                  outlined
                  color="mint"
                  class="soft-input"
                  :disable="true"
                  hint=""
                />
              </div>

              <div class="col-12 col-md-6">
                <q-input
                  v-model="novPovik.opis"
                  label="Опис"
                  type="textarea"
                  rows="1"
                  dense
                  outlined
                  color="mint"
                  class="soft-input opis-input"
                />
              </div>
            </div>

            <div class="row justify-center q-mt-lg q-gutter-sm">
              <q-btn flat label="Откажи" color="grey-7" no-caps @click="closeDialog" />

              <q-btn
                v-if="isEdit && editingRow && editingRow.status === 'непроследено'"
                outline
                label="Затвори без налог"
                color="negative"
                no-caps
                @click="zatvoriBezNalog"
              />

              <q-btn
                v-if="isEdit && editingRow && editingRow.status === 'непроследено'"
                outline
                label="Отвори налог"
                color="mint"
                no-caps
                @click="otvoriNalog({ ...editingRow, ...novPovik })"
              />

              <q-btn
                :label="isEdit ? 'Зачувај измени' : 'Додади'"
                color="mint"
                no-caps
                class="btn-save"
                type="submit"
              />
            </div>

          </q-form>
        </q-card>
      </q-dialog>

    </div>
  </q-page>
</template>

<script>
// import axios from "axios";
import api from "@/api";
import { getSitePovici } from "@/services/poviciService";
import { getUser } from "@/services/db";
import { formatDate } from "@/utils/dateFormat";
import { PoviciColumns } from "@/services/forms/povici";

// const API_BASE = "https://nalozi.megasoft.com.mk/api";

function createUiId(prefix = "UI") {
  return `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export default {
  name: "TelefonskiPovici",

  data() {
    return {
      // user: getUser(),

      povici: [],
      columns: PoviciColumns,

      dialog: false,
      isEdit: false,
      editId: null,
      editingRow: null,

      saving: false,

      currentFilter: "site",
      filterOptions: [
        { label: "Сите повици", value: "site" },
        { label: "Проследен", value: "prosleden" },
        { label: "Непроследен", value: "neprosleden" }
      ],

      firmiOptions: [],
      filteredFirmi: [],
      firmiMapa: {},

  vraboteniOptions: [],
    filteredVrab: [],
    vraboteniMapa: {},
    vraboteniRaw: [],

      novPovik: {
        klient: "",
        firma: null,
        vraboten: null,
        brojNalog: "",
        opis: "",
        prosleden: false
      }
    };
  },

  computed: {
    filteredCalls() {
      const list = this.povici || [];
      if (this.currentFilter === "prosleden") return list.filter(p => p.prosleden === true);
      if (this.currentFilter === "neprosleden") return list.filter(p => p.prosleden === false);
      return list;
    },

    pendingCount() {
      return (this.povici || []).filter(p => p._pending === true || p._dirty === true).length;
    }
  },

  methods: {
    formatDate,
notify(type, msg) {
  if (!this.$q?.notify) {
    alert(msg);
    return;
  }

  if (type === "warning") {
    this.$q.notify({
      message: msg,
      color: "white",
      textColor: "negative",
      icon: "warning",
      iconColor: "negative",
      position: "bottom",
      timeout: 2500,
      classes: "notify-required"
    });
    return;
  }

  this.$q.notify({
    type,
    message: msg,
    position: "bottom",
    timeout: 2500
  });
},

    // getLoggedUserId() {
    //   const id = Number(this.user?.username);
    //   return Number.isFinite(id) && id > 0 ? id : null;
    // },

getLoggedUser() {
  try {
    const userFromService = getUser();
    console.log("userFromService", userFromService)
    if (userFromService) return userFromService;
  } catch (e) {
  }

  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    console.log("user getLoggedUser", user)
    return user;
  } catch (e) {
    return null;
  }
},

getLoggedUserId() {
  const user = this.getLoggedUser();
  console.log("user getLoggedUserId", user)
  const id = Number(user?.id);

  return Number.isFinite(id) && id > 0 ? id : null;
},

    statusColor(status) {
      if (status === "проследено") return "positive";
      if (status === "непроследено") return "orange";
      return "grey-7";
    },

    closeDialog() {
      this.dialog = false;
    },

    resetForm() {
      this.novPovik = {
        klient: "",
        firma: null,
        vraboten: null,
        brojNalog: "",
        opis: "",
        prosleden: false
      };
    },

    openAddDialog() {
      this.isEdit = false;
      this.editId = null;
      this.editingRow = null;
      this.resetForm();
      this.dialog = true;
    },

    openEditDialog(povik) {
      this.isEdit = true;
      this.editId = povik.id;
      this.editingRow = povik;

      this.novPovik = {
        klient: povik.klient || "",
        firma: povik.firma ?? null,
        vraboten: povik.vraboten ?? null,
        brojNalog: povik.brojNalog === "-" ? "" : (povik.brojNalog || ""),
        opis: povik.opis || "",
        prosleden: !!povik.prosleden
      };

      this.dialog = true;
    },

    onSubmit() {
  if (
    !String(this.novPovik.klient || "").trim() ||
    !this.novPovik.firma ||
    !this.novPovik.vraboten
  ) {
    this.notify("warning", "Пополнете ги задолжителните полиња.");
    return;
  }

  if (!this.isEdit) {
    this.dodadiLocal();
    this.dialog = false;
    return;
  }

  this.applyEditToTableAndMarkDirty();
  this.dialog = false;
  this.notify("positive", "Изменето.");
},

    filterFirmi(val, update) {
      update(() => {
        const n = (val || "").toLowerCase();
        this.filteredFirmi = (this.firmiOptions || []).filter(o =>
          (o.label || "").toLowerCase().includes(n)
        );
      });
    },

    filterVrab(val, update) {
      update(() => {
        const n = (val || "").toLowerCase();
        this.filteredVrab = (this.vraboteniOptions || []).filter(o =>
          (o.label || "").toLowerCase().includes(n)
        );
      });
    },

    
    mapPovikFromApi(p) {
      const firma = Number(p.PartnerID ?? p.partnerID ?? p.partnerId ?? 0) || null;
      const vrab = Number(p.VrabID ?? p.vrabID ?? p.vrabId ?? 0) || null;

      const brojNalog = (p.Baranje ?? p.baranje) ?? "-";
      const hasNalog = !!brojNalog && String(brojNalog).trim() !== "-";

      const prosledeno = Boolean((p.Prosledeno ?? p.prosledeno) ?? false) || hasNalog;

      return {
        id: createUiId("DB"),
        pkid: p.pkid ?? p.PKID ?? p.Pkid ?? null,

        datum: p.Datum ?? p.datum ?? null,
        klient: p.Baral ?? p.baral ?? "",
        firma,
        vraboten: vrab,
        opis: p.Opis ?? p.opis ?? "",

        
        prosleden: prosledeno,

        brojNalog,
        status: prosledeno ? "проследено" : "непроследено",

        vrabotenIme: this.vraboteniMapa[vrab] || "-",
        firmaIme: this.firmiMapa[firma] || "-",

        _pending: false,
        _dirty: false
      };
    },

    async load() {
      const data = await getSitePovici();
      const list = Array.isArray(data) ? data : (data?.Items || data?.List || data?.list || []);
      this.povici = list.map(p => this.mapPovikFromApi(p));
    },

    async loadFirmi() {
      // const res = await axios.get(`${API_BASE}/get/firmi`);
      const res = await api.get("/get/firmi");
      const arr = Array.isArray(res.data) ? res.data : [];

      this.firmiOptions = arr.map(f => ({
        label: f.Naziv,
        value: Number(f.SifraID)
      }));
      this.filteredFirmi = this.firmiOptions;

      this.firmiMapa = {};
      arr.forEach(f => { this.firmiMapa[Number(f.SifraID)] = f.Naziv; });
    },

    async loadVraboteni() {
  // const res = await axios.get(`${API_BASE}/get/vraboteni`);
  const res = await api.get("/get/vraboteni");
  const arr = Array.isArray(res.data) ? res.data : [];

  this.vraboteniRaw = arr;

  this.vraboteniOptions = arr.map(v => ({
    label: v.Naziv,
    value: Number(v.SifraID)
  }));
  this.filteredVrab = this.vraboteniOptions;

  this.vraboteniMapa = {};
  arr.forEach(v => {
    this.vraboteniMapa[Number(v.SifraID)] = v.Naziv;
  });
},

    dodadiLocal() {
  const prosledeno = !!this.novPovik.prosleden;

  this.povici.unshift({
    id: createUiId("L"),
    pkid: null,

    datum: new Date().toISOString(),
    klient: (this.novPovik.klient || "").trim(),
    firma: Number(this.novPovik.firma),
    vraboten: Number(this.novPovik.vraboten),
    opis: (this.novPovik.opis || "").trim(),

    prosleden: prosledeno,
    brojNalog: "-",
    status: prosledeno ? "проследено" : "непроследено",

    vrabotenIme: this.vraboteniMapa[Number(this.novPovik.vraboten)] || "-",
    firmaIme: this.firmiMapa[Number(this.novPovik.firma)] || "-",

    _pending: true,
    _dirty: false
  });

  this.povici = [...this.povici];
  this.resetForm();
  this.notify("positive", "Телефонскиот повик е додаден.");
},

    applyEditToTableAndMarkDirty() {
      const idx = (this.povici || []).findIndex(p => String(p.id) === String(this.editId));
      if (idx === -1) return this.notify("negative", "Редот не е пронајден!");

      const old = this.povici[idx];
      const prosledeno = !!this.novPovik.prosleden;

      const updated = {
        ...old,

        klient: (this.novPovik.klient || "").trim(),
        firma: Number(this.novPovik.firma),
        vraboten: Number(this.novPovik.vraboten),
        opis: (this.novPovik.opis || "").trim(),

        prosleden: prosledeno,
        status: prosledeno ? "проследено" : "непроследено",

        vrabotenIme: this.vraboteniMapa[Number(this.novPovik.vraboten)] || "-",
        firmaIme: this.firmiMapa[Number(this.novPovik.firma)] || "-",

        _dirty: old._pending === true ? false : true
      };

      this.$set(this.povici, idx, updated);
      this.povici = [...this.povici];
    },

    
    removeLocal(id) {
      this.povici = (this.povici || []).filter(p => p.id !== id);
      this.notify("positive", "Повикот е избришан.");
    },

    
    zatvoriBezNalog() {
      this.novPovik.prosleden = true;
      this.applyEditToTableAndMarkDirty();
      this.dialog = false;
      this.notify("positive", "Телефонскиот повик е затворен.");
    },

    
    otvoriNalog(povik) {
      if (!povik.pkid) {
        this.notify("negative", "Повикот не е зачуван. Прво „Сними“, па потоа отвори налог.");
        return;
      }

      const data = {
        pkid: Number(povik.pkid),
        povik: true,

        klient: povik.klient,
        firma: povik.firma,
        firmaIme: povik.firmaIme,
        opis: povik.opis,

        vraboten: povik.vraboten,
        vrabotenIme: povik.vrabotenIme
      };

      localStorage.setItem("novNalogOdPovik", JSON.stringify(data));
      this.$router.push("/vraboten/azuriranje-nalozi");
    },

 async saveAllPending() {
  const loggedId = this.getLoggedUserId();

  if (!loggedId) {
    return this.notify("negative", "Не може да се пронајде ID од најавениот корисник.");
  }

  const items = (this.povici || [])
    .filter(p => p._pending === true || p._dirty === true)
    .map(p => ({
      pkid: p.pkid ?? null,
      Datum: p.datum || new Date().toISOString(),
      Baral: p.klient || "",
      PartnerID: Number(p.firma),
      VrabID: Number(loggedId),
      BaralVrabID: Number(p.vraboten),
      Opis: p.opis || "",
      Prosledeno: !!p.prosleden,
      Baranje: ""
    }));

  if (!items.length) {
    return this.notify("info", "Нема промени за снимање.");
  }

  this.saving = true;

  try {
    // await axios.post(`${API_BASE}/povici/save`, { Items: items }, {
    //   headers: { "Content-Type": "application/json" }
    // });

    await api.post("/povici/save", { Items: items }, {
  headers: { "Content-Type": "application/json" }
});

    this.notify("positive", "Промените се зачувани.");
    await this.load();
  } catch (err) {
    const msg =
      err?.response?.data?.Message ||
      err?.response?.data?.message ||
      err?.message ||
      "Грешка при снимање.";

    this.notify("negative", msg);
  } finally {
    this.saving = false;
  }
  }
},

  async mounted() {
    await this.loadVraboteni();
    await this.loadFirmi();
    await this.load();
  }
};
</script>

<style scoped>
.bg-page {
  background: #f8fbfa;
  min-height: 100vh;
}
.header-section h5 {
  font-weight: 700;
}
.btn-clean {
  border-radius: 10px;
  font-weight: 600;
  color: #0e6b5f;
  background: #f3faf9;
}
.btn-clean:hover {
  background: #e7f6f4;
}
.filter-card {
  border-radius: 14px;
}
.filter-input {
  border-radius: 10px !important;
  background: #f9fbfa !important;
}
.table-card {
  border-radius: 16px !important;
}
.table-clean thead tr {
  background: #f3f8f7;
  color: #0e6b5f;
  font-weight: 600;
}
.table-clean tbody tr:hover {
  background: #f7fdfb;
}
.dialog-card {
  width: 720px;
  max-width: 90vw;
  border-radius: 14px;
  padding: 28px 32px;
}
.dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: #0e6b5f;
  text-align: center;
}
.soft-input {
  border-radius: 10px !important;
  background: #fafdfc !important;
}
.opis-input {
  min-height: 80px;
}
.btn-save {
  background: #0e6b5f !important;
  color: white !important;
  border-radius: 10px !important;
  font-weight: 600;
}
.text-mint {
  color: #0e6b5f;
}
:deep(.required-field .q-field__label) {
  display: inline-flex !important;
  align-items: center !important;
}

:deep(.required-field .q-field__label::after) {
  content: " *";
  color: #e53935 !important;
  font-weight: 700;
}
:deep(.notify-required) {
  border: 1px solid #e53935;
}
</style>
